import { Button as MButton } from '@mantine/core';
import classes from './button.module.scss';

export const Button = MButton.extend({
  classNames: classes,
});

Button.defaultProps = {
  variant: 'primary',
};
